import { render, staticRenderFns } from "./IconRenderer.vue?vue&type=template&id=b6d7f930&"
import script from "./IconRenderer.vue?vue&type=script&lang=js&"
export * from "./IconRenderer.vue?vue&type=script&lang=js&"
import style0 from "./IconRenderer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports